import { createSlice } from '@reduxjs/toolkit'

export const DetailsReducer = createSlice({
    name: 'details',
    initialState: {
        details: null,
    },
    reducers: {
        setDetailsData: (state, action) => { state.details = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setDetailsData } = DetailsReducer.actions

export default DetailsReducer.reducer